
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"170","height":"170","viewBox":"0 0 296 296","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"148","cy":"148","r":"146","fill":"#62C886","fill-opacity":".2","stroke":"#5FD788","stroke-width":"4"}}),_c('path',{attrs:{"d":"M103.441 148l31.828 31.828 63.656-63.656","stroke":"#5FD788","stroke-width":"8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    